import axios from "axios";
import qs from "qs";
import router from "@/router";
import { message } from "ant-design-vue";

axios.defaults.crossDomain = true;
axios.defaults.withCredentials = true;

const service = axios.create({
  //  process.env.NODE_ENV === 'development' //来判断是否开发环境
  // process.env.VUE_APP_API_BASE_URL,
  //baseURL: process.env.VUE_APP_API_BASE_URL,
  withCredentials: true,
  timeout: 1200 * 1000
});



service.interceptors.request.use(
  config => {
    if (config.url !== "/production/login") {
      config.headers["accessToken"] = sessionStorage.getItem("accessToken");
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    if (response.status === 200) {
      dealError(response);
      return response.data;
    } else {
      router.push({
        path: "/login"
      });
    }
  },
  error => {
    let msg = error.response.data;
    if (error.response) {
      const { status, statusText } = error.response;
      msg = `接口状态${status},${statusText}`;
    }
    message.error(msg);
    return Promise.resolve({
      ...(error.response),
      resultStatus: false,
    });
  }
);

const dealError = function(response) {
  const responseURL = response?.request?.responseURL;
  if (responseURL.search("imagecode") > -1) return false;

  const data = response?.data;

  const errorCode = data?.errorCode;
  if (errorCode === "000403") {
    router.push({
      path: "/login"
    });
    message.error("请登陆");
    return false;
  }

  const resultStatus = response?.data?.resultStatus;
  if (resultStatus) return false;
  message.error(data.errorMessage || data.errmsg || "网络异常");


};

/**
 * 封装实际的url请求
 * @param {*} url 
 * @param {*} urlType 
 * @returns 
 */
let realUrl = (url,urlType) => {
  if(urlType === 'api'){
    return process.env.VUE_APP_API_DOMAIN_URL + url;
  }
  return process.env.VUE_APP_API_BASE_URL + url;
    
}

/**
 * 封装post请求
 * @param url
 * @param params
 */

let get = async (url, params = {},urlType) => {
  url = realUrl(url,urlType);
  return await service.get(url, { params });
};



let headersMap = {
  form: "application/x-www-form-urlencoded",
  json: "application/json"
};
let post = async (url, data = {}, formType = "json",cancel, urlType) => {
  const CancelToken = axios.CancelToken;
  if (formType === "form") {
    data = qs.stringify(data);
  }
  url = realUrl(url,urlType);
  return service.post(url, data, {
    cancelToken: new CancelToken((c) => cancel = c),
    headers: {
      "Content-Type": headersMap[formType]
    }
    // cancelToken: source.token
  });
};
let put = async (url, data = {}, formType = "json",urlType) => {
  url = realUrl(url,urlType);
  if (formType === "form") {
    data = qs.stringify(data);
  }
  return service.put(url, data, {
    headers: {
      "Content-Type": headersMap[formType]
    }
    // cancelToken: source.token
  });
};
let del = async (url, data = {}, formType = "json",urlType) => {
  url = realUrl(url,urlType);
  if (formType === "form") {
    data = qs.stringify(data);
  }
  return service.delete(url, data, {
    headers: {
      "Content-Type": headersMap[formType]
    }
    // cancelToken: source.token
  });
};
let http = async (method, url, data = {}, formType = "json",urlType) => {
  url = realUrl(url,urlType);
  if (formType === "form") {
    data = qs.stringify(data);
  }
  return service({
    method,
    url,
    data,
    headers: {
      "Content-Type": headersMap[formType]
    }
  });
};
/**
 * 封装file请求
 * @param url
 * @param data
 */
let file = async (url, data = {},urlType) => {
  url = realUrl(url,urlType);
  return await service.post(url, data)
};

export { get, post, file, put, del, http };
export default service;
